import axios from 'axios';
import { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const AttendanceSheet = ({ onUpdate }) => {
  const [date, setDate] = useState(new Date());
  const [staffList, setStaffList] = useState([]);
  const [attendanceMap, setAttendanceMap] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: staff } = await axios.get('https://api.pranucollection.com/api/staff');
        const { data: attendance } = await axios.get(
          `https://api.pranucollection.com/api/attendance?date=${date.toISOString()}`
        );

        const initialMap = {};
        staff.forEach(s => {
          const record = attendance.find(a => a.staff._id === s._id);
          initialMap[s._id] = record ? record.isPresent : false;
        });

        setStaffList(staff);
        setAttendanceMap(initialMap);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [date]);

  const handleSave = async () => {
    try {
      const attendanceArray = Object.entries(attendanceMap).map(([staffId, isPresent]) => ({
        staffId,
        isPresent
      }));

      await axios.post('https://api.pranucollection.com/api/attendance/bulk', {
        date,
        attendance: attendanceArray
      });
      onUpdate();
    } catch (error) {
      console.error('Error saving attendance:', error);
    }
  };

  return (
    <div className="p-4 bg-white rounded-lg shadow mb-8">
      <div className="flex flex-col md:flex-row gap-4 mb-6 items-end">
        <div className="w-full md:w-64">
          <label className="block mb-2 text-sm font-medium">Attendance Date</label>
          <DatePicker
            selected={date}
            onChange={setDate}
            className="w-full p-2 border rounded"
            dateFormat="dd/MM/yyyy"
          />
        </div>
        <button
          onClick={handleSave}
          className="bg-[#AB3430] text-white px-6 py-2 rounded hover:bg-[#8a2b28] h-[42px]"
        >
          Save Attendance
        </button>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead className="bg-gray-50">
            <tr>
              <th className="p-3 text-left">Staff Member</th>
              <th className="p-3 text-left">Role</th>
              <th className="p-3 text-left">Present</th>
            </tr>
          </thead>
          <tbody>
            {staffList.map(staff => (
              <tr key={staff._id} className="border-b hover:bg-gray-50">
                <td className="p-3">{staff.name}</td>
                <td className="p-3">{staff.role}</td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    checked={attendanceMap[staff._id] || false}
                    onChange={(e) => setAttendanceMap(prev => ({
                      ...prev,
                      [staff._id]: e.target.checked
                    }))}
                    className="w-4 h-4 text-[#AB3430] rounded focus:ring-[#AB3430]"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AttendanceSheet;